import { KshClassesCareerTkshCareer } from "Connectivity/Portal";
import React, { useRef, useState } from "react";
import FormRow from "02_atoms/Form/FormRow";
import { Form, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
import StyledForm from "04_organisms/Form";
import Button from "02_atoms/Button";
import Overlay from "02_atoms/Overlay";
import ActiveIndicator from "02_atoms/Form/ActiveIndicator";
import FormActionContainer from "02_atoms/Form/FormActionContainer";
import TitleWrapper from "02_atoms/Form/TitleWrapper";
import CheckboxRow from "02_atoms/Form/CheckboxRow";
import MoveActionButton from "02_atoms/Form/MoveActionButton";
import CancelButton from "02_atoms/CancelButton";
import PlaceholderTd from "02_atoms/Placeholder/PlaceholderTd";
import DateSelector from "03_molecules/DateSelector";
import NewsCountSpan from "02_atoms/Form/NewsCountSpan";
import Confirm from "02_atoms/Confirm";
import FromToForm from "02_atoms/FromToForm";
import { toInt } from "Utils/String";

type CareerProps = {
  reFetch: Function;
  reFetchWithoutNewList?: Function;
  updateCareer: Function;
  deleteCareer?: Function;
  moveUp?: Function;
  moveDown?: Function;
  career: KshClassesCareerTkshCareer;
  isNew?: boolean;
  toggleAddNew?: Function;
};

const Career: React.FunctionComponent<CareerProps> = ({
  moveDown,
  moveUp,
  reFetch,
  reFetchWithoutNewList,
  deleteCareer,
  updateCareer,
  career,
  isNew = false,
  toggleAddNew
}) => {
  const closeCareerFunction = useRef<Function>(() => { });
  const [textAreaLength, setTextAreaLength] = useState(
    career.caption ? career.caption.length : 0
  );
  const prepareDeleteCareerFunction = async (
    career: KshClassesCareerTkshCareer
  ) => {
    if (!deleteCareer) {
      return;
    }
    const careerList = await deleteCareer(career);
    closeCareerFunction.current();
    reFetch(careerList);

    return;
  };

  // @TODO get rid of any
  const onSaveChange = async (values: any) => {
    values.yearfrom = toInt(values.yearfrom);
    values.yearto = toInt(values.yearto);

    values.active = values.active ? 1 : 0;

    const careerList = await updateCareer(values);
    if (!careerList) {
      return [FORM_ERROR];
    }
    reFetch(careerList);
    closeCareerFunction.current();
  };

  return (
    <tr>
      {/* <StyledTd>
        {career.caption && career.caption.length > 50
          ? career.caption.slice(0, 50)
          : career.caption}
      </StyledTd> */}

      <TitleWrapper caption={career.caption} />

      <PlaceholderTd tdWidth={"10%"}>
        <FromToForm yearfrom={career.yearfrom} yearto={career.yearto} />
      </PlaceholderTd>
      <ActiveIndicator
        active={!!career.active}
        updateFunction={updateCareer}
        objectToUpdate={career}
        reFetch={reFetchWithoutNewList!}
      />
      <PlaceholderTd tdWidth={"10%"}>
        <Overlay
          initialOpen={isNew}
          editLabel="Beruflicher und wissenschaftlicher Werdegang"
          buttonLabel="bearbeiten"
          closeFunction={closeCareerFunction}
        >
          <Form
            initialValues={career}
            onSubmit={onSaveChange}
            render={({
              submitError,
              handleSubmit,
              form,
              submitting,
              pristine,
              values
            }) => (
                <StyledForm onSubmit={handleSubmit}>
                  <FormActionContainer>
                    <div>
                      {submitError && <div className="error">{submitError}</div>}
                      <FormRow>
                        <label>Karrierebeschreibung</label>
                        <Field
                          name="caption"
                          component="textarea"
                          placeholder="Karrierebeschreibung"
                          maxLength="500"
                          onInput={(e: any) =>
                            setTextAreaLength(e.target.value.length)
                          }
                        />{" "}
                        <NewsCountSpan>{textAreaLength} / 500</NewsCountSpan>
                      </FormRow>
                      <DateSelector item={career} />
                      <CheckboxRow>
                        <label>Auf der Webseite veröffentlichen?</label>
                        <Field name="active" component="input" type="checkbox" />
                      </CheckboxRow>
                      <FormRow>
                        <Button type="submit" disabled={submitting || pristine}>
                          Übernehmen
                      </Button>
                        <CancelButton
                          isNew={isNew}
                          closeFunction={() => closeCareerFunction.current()}
                          toggleAddNew={toggleAddNew}
                        />
                      </FormRow>
                      <FormRow>
                        {deleteCareer &&
                          <Confirm confirmFunction={() => prepareDeleteCareerFunction(career)} />
                        }
                      </FormRow>
                    </div>
                  </FormActionContainer>
                </StyledForm>
              )}
          />
        </Overlay>
      </PlaceholderTd>
      <MoveActionButton moveUp={moveUp} moveDown={moveDown} />
    </tr>
  );
};

export default Career;
